import { FormField, StatusIndicator } from '@amzn/awsui-components-react';
import { ReactElement } from 'react';
import { FieldProps } from '../FieldProps';

export const HomepageLinkCheckMapField = (
  props: FieldProps<Record<string, boolean>, true>
): ReactElement => {
  return (
    <FormField label='Homepage Link Check Map'>
      <div>
        {Object.entries(props.value).map(([key, value]) => (
          <div key={key} style={{ marginBottom: '8px' }}>
            <StatusIndicator
              type={value ? 'success' : 'error'}
              children={key}
            />
          </div>
        ))}
      </div>
    </FormField>
  );
};
